import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';

export type TaxCategoryMapping = {
  sourceSystem: string;
  sourceTaxCategory: string;
  countryPackId: string;
  taxCategory: string;
};

/** `replace` acknowledges re-pointing an existing tenant-wide conversion. */
export type TaxCategoryMappingInput = TaxCategoryMapping & { replace?: boolean };
const KEY = ['tax-category-mappings'] as const;

export function useTaxCategoryMappings(enabled: boolean) {
  return useQuery({
    queryKey: KEY,
    enabled,
    queryFn: async () => {
      const response = await apiClient.get<TaxCategoryMapping[]>('/catalog/tax-category-mappings');
      return response.data;
    },
  });
}

export function useSetTaxCategoryMapping() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: async (input: TaxCategoryMappingInput) => {
      await apiClient.put('/catalog/tax-category-mappings', input);
    },
    onSuccess: () => client.invalidateQueries({ queryKey: KEY }),
  });
}
